import { createSelector } from "@reduxjs/toolkit";

import { IUserVehicle } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { dataSelector, buildData } from "../helpers";

export const userVehiclesSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.userVehicle) as IUserVehicle[]
);

const dataUserVehiclesSelector = createSelector(dataSelector, data => data.userVehicle);

export const userVehicleSelectorCreator = (id: string) =>
  createSelector(dataUserVehiclesSelector, data => {
    const item = data?.[API_ENDPOINTS.USER_VEHICLE(id)];
    return item ? buildSingleItem(item) : undefined;
  });
